module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xfmx-box-container",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xfmx-box"
  }, [_c('div', {
    staticClass: "xfmx-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.xiaofeimingxi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "xfmx-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xfmx-list-item"
    }, [_c('div', {
      staticClass: "xfmx-list-item-left"
    }, [_c('span', {
      staticClass: "xfmx-list-item-left-span"
    }, [_vm._v(_vm._s(item.billDesc))]), _vm._v(" "), _c('span', {
      staticClass: "xfmx-list-item-left-span1"
    }, [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('span', {
      staticClass: "xfmx-list-item-span"
    }, [_vm._v(_vm._s(item.amount))])])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a59b65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaofeimingxi/xiaofeimingxi.vue
// module id = 811
// module chunks = 1